import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import client from '../api/client';

const categoryLabels = { rifle: 'بندقية', pistol: 'مسدس', shotgun: 'رماية تراب/سكيت' };
const categoryColors = { rifle: '#dc2626', pistol: '#2563eb', shotgun: '#16a34a' };

export default function ResultsHome() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => { client.get('/results/stats').then(r => setStats(r.data)); }, []);

  return (
    <div>
      <div className="grid grid-4" style={{ marginBottom: 20 }}>
        <div className="card stat-card">
          <div className="stat-num">{stats?.total_results ?? '—'}</div>
          <div className="stat-label">إجمالي النتائج المسجلة</div>
        </div>
        <div className="card stat-card">
          <div className="stat-num">{stats?.participants_with_results ?? '—'}</div>
          <div className="stat-label">عدد المشاركين لديهم نتائج</div>
        </div>
        <div className="card stat-card seal">
          <div className="stat-num">{stats?.records_count ?? '—'}</div>
          <div className="stat-label">أرقام قياسية مسجلة</div>
        </div>
        <div className="card stat-card">
          <div className="stat-num">12</div>
          <div className="stat-label">مسابقات أولمبية للرماية</div>
        </div>
      </div>

      <h3 style={{ marginBottom: 12 }}>المسابقات — اختر مسابقة لعرض نتائج الرماة</h3>
      <div className="grid grid-4">
        {stats?.perDiscipline.map(d => (
          <div
            key={d.id}
            className="card"
            style={{ cursor: 'pointer', borderTop: `4px solid ${categoryColors[d.category]}` }}
            onClick={() => navigate(`/results/${d.id}`)}
          >
            <span className="badge" style={{ background: categoryColors[d.category] }}>{categoryLabels[d.category]}</span>
            <h4 style={{ margin: '10px 0 4px' }}>{d.name_ar}</h4>
            <div style={{ fontSize: 12, color: 'var(--muted)' }}>{d.gender === 'male' ? 'رجال' : 'سيدات'}</div>
            <div style={{ marginTop: 10, fontSize: 13 }}>
              <div>عدد النتائج: <b>{d.result_count}</b></div>
              <div>أفضل نتيجة: <b className="mono">{d.best_qualification ?? '—'}</b></div>
              {d.best_holder && <div style={{ color: 'var(--muted)', fontSize: 12 }}>({d.best_holder})</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
